/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetNormDto } from './GetNormDto';
import {
    GetNormDtoFromJSON,
    GetNormDtoFromJSONTyped,
    GetNormDtoToJSON,
} from './GetNormDto';

/**
 * 
 * @export
 * @interface GetPositionNormDto
 */
export interface GetPositionNormDto {
    /**
     * 
     * @type {string}
     * @memberof GetPositionNormDto
     */
    id: string;
    /**
     * 
     * @type {GetNormDto}
     * @memberof GetPositionNormDto
     */
    norm?: GetNormDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetPositionNormDto
     */
    taskNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPositionNormDto
     */
    mode?: GetPositionNormDtoModeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPositionNormDto
     */
    resultTrue?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPositionNormDto
     */
    resultRawFrom?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPositionNormDto
     */
    resultRawTo?: number | null;
}


/**
 * @export
 */
export const GetPositionNormDtoModeEnum = {
    centyl: 'centyl',
    ten: 'ten',
    sten: 'sten',
    stanin: 'stanin',
    przeliczony: 'przeliczony'
} as const;
export type GetPositionNormDtoModeEnum = typeof GetPositionNormDtoModeEnum[keyof typeof GetPositionNormDtoModeEnum];


/**
 * Check if a given object implements the GetPositionNormDto interface.
 */
export function instanceOfGetPositionNormDto(value: object): value is GetPositionNormDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetPositionNormDtoFromJSON(json: any): GetPositionNormDto {
    return GetPositionNormDtoFromJSONTyped(json, false);
}

export function GetPositionNormDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPositionNormDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'norm': json['norm'] == null ? undefined : GetNormDtoFromJSON(json['norm']),
        'taskNumber': json['taskNumber'] == null ? undefined : json['taskNumber'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'resultTrue': json['resultTrue'] == null ? undefined : json['resultTrue'],
        'resultRawFrom': json['resultRawFrom'] == null ? undefined : json['resultRawFrom'],
        'resultRawTo': json['resultRawTo'] == null ? undefined : json['resultRawTo'],
    };
}

export function GetPositionNormDtoToJSON(value?: GetPositionNormDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'norm': GetNormDtoToJSON(value['norm']),
        'taskNumber': value['taskNumber'],
        'mode': value['mode'],
        'resultTrue': value['resultTrue'],
        'resultRawFrom': value['resultRawFrom'],
        'resultRawTo': value['resultRawTo'],
    };
}

